class ReviewCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.carousel = false;
    this.isLoading = false;

    this.classes = {
      swiper: 'swiper',
      swiperWrapper: 'swiper-wrapper',
      loading: 'is-loading',
    };

    // Bind resize handler
    this.handleResize = this.handleResize.bind(this);

    // Handle Safari separately
    const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
    if (isSafari) {
      this.init();
    } else {
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '600px 0px 600px 0px' });
    }
  }

  disconnectedCallback() {
    // Cleanup
    this.destroyCarousel();
    window.removeEventListener('resize', this.handleResize);
  }

  init() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.classList.add(this.classes.loading);

    try {
      this.initCarousel();
    } catch (error) {
      console.error('Error initializing review carousel:', error);
      this.classList.add('has-error');
    } finally {
      this.isLoading = false;
      this.classList.remove(this.classes.loading);
    }
  }

  initCarousel() {
    // if (!this.wrapper?.innerHTML.trim().length) {
    //   this.classList.add('hidden');
    //   return;
    // }

    if (typeof this.carousel !== 'object') {
      try {
        this.container.classList.add(this.classes.swiper);
        this.wrapper.classList.add(this.classes.swiperWrapper);

        let options = {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
        };

        const paginationEl = this.querySelector('.swiper-pagination');
        console.log('Pagination element found:', paginationEl);
        if (paginationEl) {
          options = {
            ...options,
            pagination: {
              el: paginationEl,
              type: 'bullets',
              clickable: true,
            },
          };
          console.log('Pagination options added:', options.pagination);
        } else {
          console.warn('No pagination element found');
        }

        // Add breakpoints for responsive behavior
        options.breakpoints = {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        };

        this.carousel = new FoxTheme.Carousel(this.slideContainer, options);

        if (this.carousel) {
          this.carousel.init();
          console.log('Carousel initialized with options:', options);
          console.log('Number of slides:', this.querySelectorAll('.swiper-slide').length);
          console.log('Pagination element after init:', this.querySelector('.swiper-pagination'));
          console.log('Pagination bullets:', this.querySelectorAll('.swiper-pagination-bullet'));
          
          // Force pagination to show if it exists
          const pagination = this.querySelector('.swiper-pagination');
          if (pagination) {
            pagination.style.display = 'block';
            pagination.style.visibility = 'visible';
            pagination.style.opacity = '1';
          }

          // Set equal heights for all slides after a small delay to ensure rendering
          setTimeout(() => {
            this.setEqualSlideHeights();
          }, 100);

          // Add resize listener to recalculate heights
          window.addEventListener('resize', this.handleResize);
        }
      } catch (error) {
        console.error('Error initializing carousel:', error);
        this.destroyCarousel();
      }
    }
  }

  destroyCarousel() {
    if (!this.wrapper?.innerHTML.trim().length) {
      this.classList.add('hidden');
      return;
    }
    this.container?.classList.remove(this.classes.swiper);
    this.wrapper?.classList.remove(this.classes.swiperWrapper);

    if (typeof this.carousel !== 'object') return;
    this.carousel.slider.destroy();
    this.carousel = false;
  }

  setEqualSlideHeights() {
    const slides = this.querySelectorAll('.swiper-slide');
    let maxHeight = 0;

    // Reset all slides to their natural height before calculating
    slides.forEach(slide => {
      slide.style.height = 'auto';
      // Force a reflow to get accurate measurements
      slide.offsetHeight;
    });

    // Calculate the maximum height
    slides.forEach(slide => {
      const slideHeight = slide.offsetHeight;
      if (slideHeight > maxHeight) {
        maxHeight = slideHeight;
      }
    });

    // Only set height if we found a valid max height
    if (maxHeight > 0) {
      slides.forEach(slide => {
        slide.style.height = maxHeight + 'px';
      });
      console.log('Set equal slide heights:', maxHeight + 'px');
    }
  }

  handleResize() {
    // Debounce resize events
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setEqualSlideHeights();
    }, 250);
  }

  get slideContainer() {
    return this.querySelector('.swiper');
  }

  get container() {
    return this.querySelector('.swiper');
  }

  get wrapper() {
    return this.querySelector('.swiper-wrapper');
  }
}

customElements.define('review-carousel-component', ReviewCarouselComponent);